import React, { Component } from 'react';
import firebase from 'firebase';
import { Modal, Button, FormGroup, FormControl, ListGroup, ListGroupItem, ControlLabel, InputGroup } from 'react-bootstrap';
import { LANG } from '../../config';

type IProps = {
  onClose: () => void,
  onImport: (item: Object) => void,
}

type IState = {
  room: string,
  items: Object,
}

class ModalImport extends Component {

  constructor(props: IProps) {
    super(props);

    this.state = {
      room: '',
      items: {},
    };
  }
  
  state: IState;

  componentDidMount() {
    this.reload();
  }

  reload() {
    const { room } = this.state;
    
    firebase.database()
    .ref(`room/${room}/words`)
    .on('value', (snapshots) => {
      this.setState({
        items: snapshots.val() || {},
      });
    });
  }

  handleOnAdd(item: Object) {
    const { onImport } = this.props;
    
    onImport({
      original: item.original,
      other: item[LANG.OTHER],
    });
  }

  handleChangeRoom(e) {
    this.setState({
      room: e.target.value.toLowerCase(),
    });
  }

  handleOnClose(e) {
    const { onClose } = this.props;

    onClose();
  }

  props: IProps;

  render() {
    const { room, items } = this.state;

    return (
      <Modal show onHide={this.handleOnClose.bind(this)} backdrop={'static'}>
        <Modal.Header closeButton>
          <Modal.Title>Import vocabulary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="original">
            <ControlLabel>Room</ControlLabel>
            <InputGroup>
              <FormControl type="text" onChange={this.handleChangeRoom.bind(this)} value={room} style={{ textTransform: 'uppercase' }} />
              <InputGroup.Button>
                <Button onClick={() => { this.reload();}}>Search</Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>
          <p>Search words in other room and click word to import.</p>
          <ListGroup>
          {
            Object.keys(items).map((key) => {
              const item = items[key];
              return (
                <ListGroupItem key={key} onClick={() => { this.handleOnAdd(item); }}>
                  {item.original}
                </ListGroupItem>
              );
            })
          }
          </ListGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleOnClose.bind(this)}>Close</Button>
        </Modal.Footer> 
      </Modal>
    );
  }
}

export default ModalImport;



// WEBPACK FOOTER //
// ./src/pages/Words/ModalImport.js